import { ChangeEvent, useState } from "react";
import "./index.css";

interface IProps {
  onclkbtn: (n: string) => void;
}

export function NameScreen(props: IProps) {
  const [value, setValue] = useState<string>("");
  const [error, setError] = useState<string>("");

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    setValue(e.target.value);
    setError("");
  }

  const onclkbtn = () => {
    if (value.trim() === "") {
      setError("Пожалуйста, введите ваше имя."); // Если имя пустое, показываем ошибку
    } else {
      props.onclkbtn(value);
    }
  };

  return (
    <>
      <div className="RegistrationConteinerText">
        <div className="textConteiner">
          <h2>Как вас зовут?</h2>
          <p>Мы хотели бы обращаться к вам с особым вниманием и заботой</p>

          <input
            type="text"
            value={value}
            onChange={handleChange}
            placeholder="Имя"
            required
            autoFocus
            maxLength={25}
            onKeyUp={(e) => {
              if (e.code === "Enter") {
                onclkbtn();
              }
            }}
          />
          {error && <p className="error-message">{error}</p>}
        </div>
      </div>
      <div className="registration-button" onClick={onclkbtn}>
        Далее
      </div>
    </>
  );
}
